import { Middleware } from 'redux';
import RootState from 'state/RootState';
import { getStoreState } from 'state/Store';
import { controllerIsVisible, isMobileLayout } from 'utils';

import {
  CLOSE_MODAL,
  CLOSE_PAGE,
  SPLIT_LAYER,
  HIDE_MOBILE_CONTROLLER,
  togglePlayback,
  APP_DID_ENTER_FOREGROUND
} from '../actions';

export const resumePlaybackMiddleware: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);

    const {
      flyer: { isPlaying, shouldPlay },
      app: { history }
    } = store.getState() as RootState;

    if (action.dontResumePlayback) {
      return;
    }

    const isMobile = isMobileLayout();

    if (
      !isPlaying &&
      shouldPlay &&
      [
        CLOSE_MODAL,
        CLOSE_PAGE,
        SPLIT_LAYER,
        HIDE_MOBILE_CONTROLLER,
        APP_DID_ENTER_FOREGROUND
      ].includes(action.type)
    ) {
      setTimeout(() => {
        if (
          history.location.pathname !== '/buy' &&
          history.location.pathname !== '/account' &&
          getStoreState().app.openedModals.length === 0 &&
          (!isMobile || !controllerIsVisible())
        ) {
          store.dispatch(togglePlayback());
        }
      }, 100);
    }
  };



// WEBPACK FOOTER //
// ./src/state/side-effects/resumePlayback.ts